export const POPUP_TYPES = {
  ADD_GROUP: "ADD_GROUP",
  ADD_FORM_ELEMENT: "ADD_FORM_ELEMENT",
};
